import './Routes.css';
import { forwardRef, useEffect, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { Input, Table } from 'reactstrap';
import sortObjectsArray from 'sort-objects-array';
import Select from './Select';
import { AddressAutoComplete } from './AdressAutoComplete';
import CustomMap from './Map';
import Toast from '../../../Toast/Toast';

const defaultLocation = [
    {
        latitude: -23.5505199,
        longitude: -46.6333094,
    },
];

const Routes = forwardRef((props, ref) => {
    let [items, updateItems] = useState([]);
    const [places, setPlaces] = useState([]);

    useEffect(() => {
        if (props.value) {
            let value = sortObjectsArray(props.value, 'index');
            updateItems(value);

            let tempPlaces = [];

            value.forEach((element, index) => {
                if (element.select) {
                    tempPlaces.push({
                        latitude: element.select.lat,
                        longitude: element.select.lng,
                    });
                }
                if (element.autocomplete) {
                    tempPlaces.push({
                        latitude: element.autocomplete.lat,
                        longitude: element.autocomplete.lng,
                    });
                }
            });

            setPlaces(tempPlaces);
        } else {
            let tempItem = {};

            if (props.inputType == 'autocomplete') {
                tempItem.autocomplete = '';
                tempItem.name = '';
            } else if (props.inputType == 'select') {
                tempItem.select = '';
            }

            let tempItems = [];

            tempItems.push(tempItem);
            updateItems(tempItems);
        }
    }, []);

    const clickAdd = () => {
        let tempItem = {};

        if (props.inputType == 'autocomplete') {
            tempItem.autocomplete = '';
            tempItem.name = '';
        } else if (props.inputType == 'select') {
            tempItem.select = '';
        }

        let tempItems = [];

        items.forEach((element, index) => {
            tempItems.push(element);
        });

        tempItems.push(tempItem);
        updateItems(tempItems);

        props.onAdd({
            target: {
                name: props.name,
                value: tempItems,
            },
        });
    };

    const onDelete = (index) => {
        if (items.length > 1) {
            let tempItems = [...items];
            let placesTemp = [...places];

            tempItems.splice(index, 1);

            placesTemp.splice(index, 1);

            updateItems(tempItems);
            setPlaces(placesTemp);

            Toast.success('Ponto removido com sucesso!');

            props.onDelete({
                target: {
                    name: props.name,
                    value: tempItems,
                },
            });
        }
    };

    const handleChange = async (event, index, type) => {
        let tempItems = [];
        items.forEach((element, index2) => {
            if (index == index2) {
                switch (type) {
                    case 'select':
                        element.select = {
                            label: event.target.label,
                            value: event.target.value,
                            lat: event.target.lat,
                            lng: event.target.lng,
                            fullAddress: event.target.fullAddress,
                        };

                        const newSelectPlaces = [...places];

                        newSelectPlaces[index] = {
                            latitude: event.target.lat,
                            longitude: event.target.lng,
                        };

                        setPlaces(newSelectPlaces);
                        break;
                    case 'autocomplete':
                        element.autocomplete = {
                            fullAddress: event.target.value.fullAddress,
                            lat: event.target.value.lat,
                            lng: event.target.value.lng,
                        };

                        const newAutocompletePlaces = [...places];

                        newAutocompletePlaces[index] = {
                            latitude: event.target.value.lat,
                            longitude: event.target.value.lng,
                        };

                        setPlaces(newAutocompletePlaces);
                        break;
                    default:
                        element.name = event.target.value;
                        break;
                }
            }
            tempItems.push(element);
        });

        updateItems(tempItems);

        props.onChange({
            target: {
                name: props.name,
                value: items,
            },
        });
    };

    const inputType = (index, item) => {
        switch (props.inputType) {
            case 'select':
                return (
                    <td>
                        <Select
                            name="select"
                            value={items[index].select}
                            onChange={(event) => {
                                handleChange(event, index, 'select');
                            }}
                            isClearable={props.selectParams.isClearable ? props.selectParams.isClearable : true}
                            options={props.selectParams.options}
                            optionsEndpoint={props.selectParams.optionsEndpoint}
                            disabled={!!props.readOnly}
                            error={props.error}
                        />
                    </td>
                );
                break;
            case 'autocomplete':
                return (
                    <>
                        <td style={{ width: '20%' }}>
                            <Input
                                onChange={(event) => {
                                    handleChange(event, index, 'text');
                                }}
                                value={items[index].name}
                                type="text"
                                name="name"
                                maxLength={item.maxLength ? item.maxLength : 20}
                                readOnly={!!props.readOnly}
                            />
                        </td>
                        <AddressAutoComplete
                            type="text"
                            name="autocomplete"
                            value={items[index].autocomplete}
                            onChange={(event) => {
                                handleChange(event, index, 'autocomplete');
                            }}
                            maxLength={255}
                            readOnly={!!props.readOnly}
                            error={props.error}
                        />
                    </>
                );
                break;
        }
    };

    return (
        <div
            className="d-flex routes-container"
            style={{ gap: '20px', height: '500px' }}
            ref={ref}
        >
            <div className="d-flex justify-content-between flex-column table-container">
                <div className="d-flex flex-column w-100 table-small-container h-100 position-relative">
                    <Table>
                        <thead>
                            <tr>
                                {props.inputType == 'select' && (
                                    <th>Ponto de Parada</th>
                                )}
                                {props.inputType == 'autocomplete' && (
                                    <>
                                        <th>Nome</th>
                                        <th>Endereço</th>
                                    </>
                                )}
                                {!props.readOnly && <th>Excluir</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {items &&
                                items.map((item, index) => {
                                    return (
                                        <tr key={`${items.length}${index}`}>
                                            {props.inputType &&
                                                inputType(index, item)}
                                            <td style={{ width: '5%' }}>
                                                {!props.readOnly && (
                                                    <div className="d-flex justify-content-center">
                                                        <a
                                                            className="btn btn-danger btn-sm btn-action"
                                                            onClick={() => {
                                                                onDelete(index);
                                                            }}
                                                            data-tip
                                                            data-for={
                                                                'tooltip-delete-' +
                                                                index
                                                            }
                                                            data-testid={`excluir-${index}`}
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                        </a>
                                                        <ReactTooltip
                                                            id={
                                                                'tooltip-delete-' +
                                                                index
                                                            }
                                                            place="top"
                                                            effect="solid"
                                                        >
                                                            Excluir
                                                        </ReactTooltip>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </Table>
                </div>
                {!props.readOnly && (
                    <div className="d-flex justify-content-center">
                        <button
                            onClick={clickAdd}
                            type="button"
                            className="btn btn-primary"
                            style={{ marginRight: '10px', width: '70%' }}
                            disabled={places.length !== items.length}
                        >
                            Adicionar Ponto
                        </button>
                    </div>
                )}
            </div>

            <CustomMap places={places.length > 0 ? places : defaultLocation} />
        </div>
    );
})

export default Routes;
